import React from 'react';
import GameActivitySetUpBase from '../GameActivitySetUpBase';

const BackgammonGameSetUp = (props) => <GameActivitySetUpBase {...props} />;
BackgammonGameSetUp.displayName = 'BackgammonGameSetUp';

export default React.memo(BackgammonGameSetUp);
